var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-budget"},[_c('span',{staticClass:"m-budget__title"},[_vm._v("Budget")]),_vm._v(" "),_c('span',{staticClass:"m-budget__value"},[_c('span',{staticClass:"u-font-backup m-budget__symbol"},[_vm._v("£")]),_vm._v(_vm._s(_vm._f("currency")(_vm.getBudget))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3a0adb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Budget.vue
// module id = null
// module chunks = 